// extracted by mini-css-extract-plugin
module.exports = {"clamp":"style_clamp___zNCC","desc":"style_desc__133mI","shortDesc":"style_shortDesc__DSMBN","flag":"style_flag__R5E4t"};